@if(isLoading){
@for(s of [0,1,2,3] ; track s){
<div class="flex flex-col p-4 border rounded-2xl shadow-sm m-2 gap-y-1 cursor-pointer text-sm animate-pulse bg-white">
    <div class="flex justify-between">
        <div class="flex flex-1 justify-between text-start pr-2">
            <div class="h-4 w-32 bg-gray-200 rounded"></div>
            <div class="h-5 w-16 bg-gray-200 rounded-full"></div>
        </div>
        <div class="h-5 w-5 bg-gray-200 rounded-full"></div>
    </div>

    <div class="flex flex-col gap-y-2 mt-2">
        <div class="h-3 w-full bg-gray-200 rounded"></div>
        <div class="h-3 w-3/4 bg-gray-200 rounded"></div>
    </div>
    <div class="flex items-center mt-3 gap-x-2">
        <div class="h-6 w-6 bg-gray-200 rounded-base"></div>
        <div class="h-4 w-24 bg-gray-200 rounded"></div>
    </div>
</div>
}

}
@else{
<div class="inn-flex-container flex flex-col justify-center h-full">
    @if(!linkDocs || linkDocs.length === 0) {
    <div class="flex flex-col justify-evenly h-full items-center gap-2 p-2 my-3">
        <div class="link-file">
            <img [src]="'images/link-files.png' | assetUrl" alt="link" class="relative z-0">
            <div class="vector-left">
                <img [src]="'images/orange-top.svg' | assetUrl" alt="">
            </div>
            <div class="vector-right">
                <img [src]="'images/blue-bottom.svg' | assetUrl" alt="">
            </div>
        </div>
        <div>
            <h2 class="font-semibold text-base text-center">Link Documents</h2>
            <p class="info text-sm">You can connect documents which are relevant to each other</p>
        </div>
        <div class="flex flex-col gap-2 w-full relative z-20">
            <div class="flex items-center justify-center w-full">
                <app-button (clicked)="openCreateDoc()" label="Generate Document to Link" variant="filled"
                    severity="primary" />
            </div>
            <div class="flex gap-2 justify-center w-full">
                <app-button (clicked)="openExistingDoc()" label="Link Existing Documents" variant="outlined"
                    severity="contrast" />
                <app-button (clicked)="openUploadDoc()" label="Upload New Document" variant="outlined"
                    severity="contrast" />
            </div>
        </div>
    </div>
    } @else {
    <div class="flex flex-col h-full">
        <div class="list">
            @for (doc of linkDocs; track doc._id) {
            <div class="flex flex-col p-4 border rounded-2xl shadow-sm m-2 gap-y-1 cursor-pointer text-sm"
                (click)="openDocument(doc.targetDocument._id)">
                <div class="flex justify-between">
                    <div class="flex flex-1  justify-between text-start pr-2">
                        <div class="font-semibold text-gray-900">{{ doc.targetDocument.name }}</div>
                        <app-badge [contract]="doc.targetDocument" />
                    </div>
                    <app-popover #menu>
                        <ng-template #trigger>
                            <div class="cursor-pointer" (click)="menu.toggle(); $event.stopPropagation()">
                                <i class="pi pi-ellipsis-v"></i>
                            </div>
                        </ng-template>
                        <ng-template #body>
                            <div class="flex flex-col">
                                <div class="flex items-center !p-0 cursor-pointer hover:bg-gray-100 transition-colors"
                                    (click)="handleMenuItemClick($event, doc._id, { label: 'Unlink', icon: 'pi pi-trash', route: [] })">
                                    <i class="pi pi-trash text-danger"></i>
                                    <span class="ml-2 text-sm text-danger">Unlink</span>
                                </div>
                            </div>
                        </ng-template>
                    </app-popover>
                </div>
                @if(doc.targetDocument.summary) {
                <div class="flex text-sm text-gray-500">
                    <markdown class="text-justify truncate-summary" [data]="doc.targetDocument.summary"></markdown>
                </div>
                } @else {
                <div class="flex text-sm text-gray-500">No summary available</div>
                }
                <div class="flex items-center mt-2">
                    <app-user-name-display [user]="doc.targetDocument.createdBy"
                        [variant]="'avatar-name'"></app-user-name-display>
                </div>
            </div>
            }
        </div>
        <div class="buttons">
            <div class="flex flex-col gap-2 w-full justify-center">
                <div class="flex items-center justify-center">
                    <app-button (clicked)="openCreateDoc()" label="Generate Document to Link" variant="filled"
                        severity="primary" />
                </div>
                <div class="flex gap-2 w-full justify-center">
                    <app-button (clicked)="openExistingDoc()" label="Link Existing Documents" variant="outlined"
                        severity="contrast" />
                    <app-button (clicked)="openUploadDoc()" label="Upload New Document" variant="outlined"
                        severity="contrast" />
                </div>
            </div>
        </div>
    </div>
    }
</div>

}

<app-ai-assistant [(visible)]="isCreateDocOpen" (onGenerate)="closeDialog($event)"></app-ai-assistant>

<app-file-selection [(visible)]="isExistingDocOpen" [config]="fileSelectionConfig" [fetch]="fileSelectionFetch"
    [fileItemTemplate]="fileItemTemplate" [selectedFileTemplate]="selectedFileTemplate"
    (onSubmit)="onFileSelectionSubmit($event)" (onCancel)="handleDialogClose()">

    <!-- Custom file item template -->
    <ng-template #fileItemTemplate let-file let-selected="selected" let-toggleSelection="toggleSelection">
        <div class="flex flex-row items-center gap-3">
            <app-checkbox [value]="selected" [config]="{ binary: true }" (onChange)="toggleSelection($event)" />

            <div class="flex flex-1 flex-row items-center gap-2 min-w-0">
                <app-file-icon [type]="getFileType(file.name)" size="xxl" />
                <div class="flex flex-col items-start gap-1 w-full min-w-0">
                    <span class="font-semibold text-xs text-gray-900 truncate w-full" [pTooltip]="file.name"
                        tooltipPosition="bottom">{{
                        file.name
                        }}</span>
                    <div class="flex justify-between items-center w-full">
                        @if(file.metadata?.originalContract?.createdAt) {
                        <span class="text-xs text-gray-500 shrink-0">
                            {{ file.metadata.originalContract.createdAt | dateFormatter }}
                        </span>
                        }
                        @if(file.metadata?.originalContract?.createdBy) {
                        <app-user-name-display [user]="file.metadata.originalContract.createdBy"
                            [variant]="'avatar-name'" [size]="'xs'"
                            [class]="'text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis shrink-0'"></app-user-name-display>
                        }
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- Custom selected file template (right panel) -->
    <ng-template #selectedFileTemplate let-file let-selected="selected" let-toggleSelection="toggleSelection">
        <div class="flex flex-row items-center gap-3">
            <div class="flex flex-1 flex-row items-center gap-2 min-w-0">
                <app-file-icon [type]="getFileType(file.name)" size="xxl" />
                <div class="flex flex-col items-start gap-1 w-full min-w-0">
                    <span class="font-semibold text-xs text-gray-900 truncate w-full" [pTooltip]="file.name"
                        tooltipPosition="bottom">{{
                        file.name
                        }}</span>
                    <div class="flex justify-between items-center w-full">
                        @if(file.metadata?.originalContract?.createdAt) {
                        <span class="text-xs text-gray-500">
                            {{ file.metadata.originalContract.createdAt | dateFormatter }}
                        </span>
                        }
                    </div>
                </div>
                <app-button variant="outlined" severity="danger" icon="pi pi-trash" size="sm"
                    (clicked)="toggleSelection({ checked: false })" />
            </div>
        </div>
    </ng-template>
</app-file-selection>